<team-message>
<div class="team-background">
  <span if={ props.about }>
    <p class="team-message">{ props.about }</p>
  </span>
</div>
</team-message>